'use es6';
import I18n from 'I18n';

export default () => I18n.locale;
